import { savePDF } from '@progress/kendo-react-pdf';

class DocService {
  createPdf = (html) => {
   
    savePDF(html, {
      paperSize: 'A2',
      fileName: 'benchmark.pdf',
      margin: 30,
      fontSize: 12
    });
    
  }
}

const Doc = new DocService();
export default Doc;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmark/DocService.js